<template>
  <q-dialog v-model="Show" persistent @hide="CerrarModal">
    <q-card style="width: 750px; max-width: 95vw; max-height: 90vh; display: flex; flex-direction: column;" class="rounded-borders shadow-4">
      <!-- Encabezado del Modal con botón Guardar Fijo -->
      <q-card-section class="bg-primary text-white row items-center justify-between q-py-sm shrink-0">
        <div class="text-h6 text-weight-bold row items-center">
          <q-icon name="event" class="q-mr-sm" size="sm" />
          <span>Servicio Vencimientos</span>
        </div>
        <div class="row items-center q-gutter-xs">
          <q-btn
            color="white"
            text-color="primary"
            label="Guardar"
            icon="save"
            unelevated
            dense
            no-caps
            class="q-px-md text-weight-bold"
            :loading="isLoading"
            :disable="EstadoBoton"
            @click="GuardarServicio"
          >
            <q-tooltip>Guardar cambios de vencimiento</q-tooltip>
          </q-btn>
          <q-btn icon="close" flat round dense v-close-popup @click="CerrarModal" />
        </div>
      </q-card-section>

      <!-- Cuerpo del Modal con Scroll -->
      <q-card-section class="col overflow-auto q-pa-md q-gutter-y-md">
        <div class="row q-col-gutter-md">
          <div class="col-12 col-sm-4">
            <q-input
              v-model="ServicioVent.ruc"
              label="RUC"
              outlined
              dense
              disable
            />
          </div>
          <div class="col-12 col-sm-8">
            <q-input
              v-model="ServicioVent.descripcion"
              label="Servicio Descripción"
              outlined
              dense
              disable
            />
          </div>
        </div>

        <q-separator />

        <div class="row q-col-gutter-md">
          <div class="col-12 col-sm-6">
            <q-input
              v-model="ServicioVent.inicio"
              type="date"
              label="Fecha de Inicio"
              outlined
              dense
              stack-label
            />
          </div>
          <div class="col-12 col-sm-6">
            <q-input
              v-model="ServicioVent.vencimiento"
              type="date"
              label="Fecha de Vencimiento *"
              outlined
              dense
              stack-label
            />
          </div>
        </div>

        <div class="row q-col-gutter-md">
          <div class="col-12 col-sm-6">
            <q-select
              v-model="ServicioVent.estado"
              :options="[
                { label: 'Vigente', value: 'V' },
                { label: 'Anulado', value: 'A' }
              ]"
              option-value="value"
              option-label="label"
              emit-value
              map-options
              label="Estado"
              outlined
              dense
            />
          </div>
          <div class="col-12 col-sm-6">
            <q-input
              v-model="ServicioVent.observaciones"
              label="Observaciones"
              outlined
              dense
            />
          </div>
        </div>

        <!-- Botón rápido directo sobre la tabla para mayor comodidad táctil en celular -->
        <div class="row justify-end q-mt-sm">
          <q-btn
            color="primary"
            label="Guardar Vencimiento"
            icon="save"
            unelevated
            no-caps
            class="full-width-xs text-weight-bold"
            :loading="isLoading"
            :disable="EstadoBoton"
            @click="GuardarServicio"
          />
        </div>

        <q-separator />

        <!-- Tabla de Vencimientos -->
        <div class="row items-center justify-between q-mb-xs">
          <div class="text-subtitle2 text-weight-bold text-grey-8">
            Historial de Vencimientos ({{ ListaData.length }}):
          </div>
        </div>

        <q-table
          :data="ListaData"
          :columns="columns"
          :row-key="row => row.id || row.idServicioVencimiento || Math.random()"
          :grid="$q.screen.xs"
          flat
          bordered
          dense
          no-data-label="No hay vencimientos registrados"
        >
          <!-- Slot Grid para Móviles (Pantallas Celular) -->
          <template v-slot:item="props">
            <div class="q-pa-xs col-xs-12 col-sm-6">
              <q-card class="shadow-1 rounded-borders bg-white overflow-hidden">
                <q-card-section class="bg-grey-2 q-pa-xs row items-center justify-between">
                  <div class="text-subtitle2 text-weight-bold text-primary">
                    ID: {{ props.row.id || props.row.idServicioVencimiento || '-' }}
                  </div>
                  <q-badge :color="props.row.estado === 'V' ? 'positive' : 'negative'" class="text-weight-bold">
                    {{ props.row.estado === 'V' ? 'Vigente' : 'Anulado' }}
                  </q-badge>
                </q-card-section>

                <q-separator />

                <q-card-section class="q-pa-sm text-caption">
                  <div class="row q-col-gutter-xs">
                    <div class="col-6">
                      <div class="text-grey-7">Fecha Inicio</div>
                      <div class="text-weight-medium">{{ props.row.inicio || '-' }}</div>
                    </div>
                    <div class="col-6 text-right">
                      <div class="text-grey-7">Fecha Vencimiento</div>
                      <div class="text-weight-bold text-primary">{{ props.row.vencimiento || '-' }}</div>
                    </div>
                  </div>
                  <div v-if="props.row.observaciones" class="q-mt-xs text-grey-8">
                    <strong>Obs:</strong> {{ props.row.observaciones }}
                  </div>
                </q-card-section>

                <q-separator />

                <q-card-actions align="right" class="q-pa-xs bg-grey-1">
                  <q-btn
                    outline
                    dense
                    no-caps
                    color="negative"
                    icon="delete"
                    label="Eliminar Vencimiento"
                    class="full-width text-weight-bold bg-white"
                    @click="EliminarVencimiento(props.row)"
                  />
                </q-card-actions>
              </q-card>
            </div>
          </template>

          <template v-slot:body-cell-estado="props">
            <q-td :props="props" class="text-center">
              <q-badge :color="props.row.estado === 'V' ? 'positive' : 'negative'" class="text-weight-bold">
                {{ props.row.estado === 'V' ? 'Vigente' : 'Anulado' }}
              </q-badge>
            </q-td>
          </template>

          <template v-slot:body-cell-acciones="props">
            <q-td :props="props" class="text-center">
              <q-btn
                flat
                round
                dense
                color="negative"
                icon="delete"
                @click="EliminarVencimiento(props.row)"
              >
                <q-tooltip>Eliminar Vencimiento</q-tooltip>
              </q-btn>
            </q-td>
          </template>
        </q-table>
      </q-card-section>

      <!-- Pie del Modal Fijo -->
      <q-card-actions align="right" class="q-pa-md bg-grey-1 shrink-0">
        <q-btn
          flat
          label="Cancelar"
          color="grey-7"
          no-caps
          @click="CerrarModal"
        />
        <q-btn
          color="primary"
          label="Guardar Vencimiento"
          icon="save"
          unelevated
          no-caps
          :loading="isLoading"
          :disable="EstadoBoton"
          class="text-weight-bold"
          @click="GuardarServicio"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "EmpresaServicioVencimientoModal",
  props: {
    DialogServicio: {
      type: Boolean,
      required: true,
      default: false,
    },
    ServicioVent: {
      type: Object,
      required: false,
      default: () => ({
        idServicioVencimiento: "",
        ruc: "",
        idServicioEmpresa: "",
        inicio: new Date().toISOString().substr(0, 10),
        vencimiento: "",
        estado: "V",
        observaciones: "",
      }),
    },
  },
  data() {
    return {
      isLoading: false,
      Show: this.DialogServicio,
      EstadoBoton: false,
      ListaData: [],
      columns: [
        { name: "id", label: "ID", field: row => row.id || row.idServicioVencimiento, align: "left" },
        { name: "inicio", label: "Inicio", field: "inicio", align: "center" },
        { name: "vencimiento", label: "Vencimiento", field: "vencimiento", align: "center" },
        { name: "estado", label: "Estado", field: row => row.estado === "V" ? "Vigente" : "Anulado", align: "center" },
        { name: "observaciones", label: "Observaciones", field: "observaciones", align: "left" },
        { name: "acciones", label: "Acciones", field: "acciones", align: "center" },
      ],
    };
  },
  watch: {
    DialogServicio(newVal) {
      this.Show = newVal;
      if (newVal) {
        this.GetListaVencimiento();
      }
    },
    ServicioVent: {
      handler(newVal) {
        if (this.Show && newVal) {
          this.GetListaVencimiento();
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.DialogServicio) {
      this.GetListaVencimiento();
    }
  },
  methods: {
    GetListaVencimiento() {
      let me = this;
      const svc = me.ServicioVent || {};
      const payload = {
        ...svc,
        idServicioEmpresa: svc.idServicioEmpresa || svc.id || "",
        ruc: svc.ruc || ""
      };
      console.log(payload);
      axios.post("ApiWeb/ServicioListaVencimiento.php", payload, { params: payload })
        .then((response) => {
          console.log(response);
          if (response.data && Array.isArray(response.data.data)) {
            me.ListaData = response.data.data;
          } else if (response.data && Array.isArray(response.data)) {
            me.ListaData = response.data;
          } else if (response.data && Array.isArray(response.data.vencimientos)) {
            me.ListaData = response.data.vencimientos;
          } else {
            me.ListaData = [];
          }
        })
        .catch((error) => {
          console.error("Error GetListaVencimiento:", error);
          me.ListaData = [];
        });
    },
    EliminarVencimiento(data) {
      if (confirm("¿Desea eliminar este vencimiento?")) {
        let me = this;
        const targetId = data.id || data.idServicioVencimiento;
        axios.post("ApiWeb/ServicioVencimientoEliminar.php", {
          idServicioVencimiento: targetId,
          id: targetId
        }, {
          params: { idServicioVencimiento: targetId, id: targetId }
        })
          .then(() => {
            me.notificar("Registro Eliminado", "positive");
            me.GetListaVencimiento();
          })
          .catch((error) => {
            console.error("Error EliminarVencimiento:", error);
          });
      }
    },
    GuardarServicio() {
      let me = this;
      this.isLoading = true;
      this.EstadoBoton = true;
      const svc = me.ServicioVent || {};
      const payload = {
        ...svc,
        idServicioEmpresa: svc.idServicioEmpresa || svc.id || "",
        ruc: svc.ruc || ""
      };
      axios.post("ApiWeb/ServicioVencimientoAgregar.php", payload, { params: payload })
        .then((response) => {
          if (response.data && response.data.estado === "ERROR") {
            this.notificar(response.data.mensaje || "Error al guardar", "warning");
          } else {
            const msg = (response.data && response.data.mensaje) || "Vencimiento guardado exitosamente";
            this.notificar(msg, "positive");
            this.GetListaVencimiento();
            this.$emit("ActualizarLista");
          }
        })
        .catch((error) => {
          console.error("Error GuardarServicio:", error);
        })
        .finally(() => {
          this.isLoading = false;
          this.EstadoBoton = false;
        });
    },
    notificar(msg, color) {
      if (this.$q && this.$q.notify) {
        this.$q.notify({
          message: msg,
          color: color,
          position: "top-right",
          timeout: 3000
        });
      } else {
        alert(msg);
      }
    },
    CerrarModal() {
      this.Show = false;
      this.$emit("CerrarModal");
    },
  },
};
</script>
